import { useState } from 'react'
import { useTheme } from '../../contexts/ThemeContext'
import 'primeicons/primeicons.css'

interface FormInputProps {
  label: string
  name: string
  type: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  required?: boolean
  minLength?: number
}

export default function FormInput({
  label,
  name,
  type,
  value,
  onChange,
  placeholder,
  required = false,
  minLength
}: FormInputProps) {
  const { theme } = useTheme()
  const [showPassword, setShowPassword] = useState(false)

  const isPassword = type === 'password'
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type

  return (
    <div>
      <label className={`block font-semibold mb-2 ${theme === 'dark' ? 'text-gold-400' : 'text-gold-500'}`}>
        {label}
      </label>
      <div className="relative">
        <input
          type={inputType}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          minLength={minLength}
          className={`w-full px-4 py-3 rounded-lg border-2 focus:outline-none transition
            ${isPassword ? 'pr-12' : ''}
            ${theme === 'dark'
              ? 'bg-black border-gold-500 text-white focus:border-gold-400 placeholder-gray-500'
              : 'bg-white border-gold-400 text-gray-900 focus:border-gold-500 placeholder-gray-400'
            }`}
          placeholder={placeholder}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className={`absolute right-3 top-1/2 -translate-y-1/2 p-1 transition-colors ${theme === 'dark'
                ? 'text-gray-400 hover:text-gold-400'
                : 'text-gray-400 hover:text-gold-500'
              }`}
            tabIndex={-1}
            aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}
          >
            <i className={`pi ${showPassword ? 'pi-eye-slash' : 'pi-eye'} text-lg`} />
          </button>
        )}
      </div>
    </div>
  )
}
